import { createContext, useContext, useState, ReactNode } from 'react'
import { platformLogin as apiLogin } from '../api/platformClient'

interface PlatformAuthCtx {
  token: string | null
  username: string | null
  email: string | null
  mustChangePassword: boolean
  doLogin: (u: string, p: string) => Promise<void>
  doLogout: () => void
  clearMustChangePassword: () => void
}

const Ctx = createContext<PlatformAuthCtx>(null!)

export function PlatformAuthProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(localStorage.getItem('platform_token'))
  const [username, setUsername] = useState<string | null>(localStorage.getItem('platform_username'))
  const [email, setEmail] = useState<string | null>(localStorage.getItem('platform_email'))
  const [mustChangePassword, setMustChangePassword] = useState<boolean>(
    localStorage.getItem('platform_mustChangePassword') === 'true',
  )

  const doLogin = async (u: string, p: string) => {
    const res = await apiLogin(u, p)
    const { access_token, admin, mustChangePassword: mcp } = res.data
    localStorage.setItem('platform_token', access_token)
    localStorage.setItem('platform_username', admin.username)
    localStorage.setItem('platform_email', admin.email)
    localStorage.setItem('platform_mustChangePassword', String(mcp))
    setToken(access_token)
    setUsername(admin.username)
    setEmail(admin.email)
    setMustChangePassword(mcp)
  }

  const doLogout = () => {
    localStorage.removeItem('platform_token')
    localStorage.removeItem('platform_username')
    localStorage.removeItem('platform_email')
    localStorage.removeItem('platform_mustChangePassword')
    setToken(null); setUsername(null); setEmail(null); setMustChangePassword(false)
  }

  const clearMustChangePassword = () => {
    localStorage.setItem('platform_mustChangePassword', 'false')
    setMustChangePassword(false)
  }

  return (
    <Ctx.Provider value={{ token, username, email, mustChangePassword, doLogin, doLogout, clearMustChangePassword }}>
      {children}
    </Ctx.Provider>
  )
}

export function usePlatformAuth() {
  return useContext(Ctx)
}
